<register-panel #registerPanel></register-panel>
